import ReactGA from 'react-ga4';
import { subscribe } from './event-logger';
import { EVENT_TYPES } from './event-types';

const ga4Tracker = {
    init(trackerId) {
        ReactGA.initialize(trackerId);
    },

    trackPageView() {
        ReactGA.send('pageview');
    }
}

subscribe(eventType => {
    if (eventType === EVENT_TYPES.PAGE_VIEW) {
        ga4Tracker.trackPageView();
    }
})

export {
    ga4Tracker
}
